import { SET_LIST_SUBJECT } from './subjectConst';

export function setListSubject(subject) {
  return {
    type: SET_LIST_SUBJECT,
    subject
  };
}
